module.exports = __webpack_public_path__ + "img/rural4.337c0762.jpg";